import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const isMDM = true;
const brandGet = async (options) => {
  const resourcePath = `${Constants.PATH.MDM.BRANDS.brand}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options,
      isMDM
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export { brandGet };
